import type { EnvironmentHosts } from './interface'

export const getHosts = (env: Record<string, string | undefined>): EnvironmentHosts => {
  const environmentStand = env.NUXT_PUBLIC_ENVIRONMENT_STAND
  const isProduction = env.NODE_ENV === 'production'

  const configs = {
    dev: {
      externalHost: 'https://svoevagro-nuxt-dev.sz.rshbcloud.ru',
      authHost: 'https://svoefermerstvo-dev.sz.rshbcloud.ru',
      agroclassesHost: 'https://agroclasses-dev.sz.rshbcloud.ru',
    },
    test: {
      externalHost: 'https://svoevagro-nuxt-test.sz.rshbcloud.ru',
      authHost: 'https://svoefermerstvo-test.sz.rshbcloud.ru',
      agroclassesHost: 'https://agroclasses-dev.sz.rshbcloud.ru',
    },
    preprod: {
      externalHost: 'https://svoevagro-nuxt-preprod.sz.rshbcloud.ru',
      authHost: 'https://svoefermerstvo-preprod.sz.rshbcloud.ru',
      agroclassesHost: 'https://agroclasses-dev.sz.rshbcloud.ru',
    },
    prod: {
      externalHost: 'https://svoevagro.ru',
      authHost: 'https://svoefermerstvo.ru',
      agroclassesHost: 'https://agroclasses.svoevagro.ru',
    },
  }

  const selectedConfig = configs[environmentStand as keyof typeof configs] || {
    externalHost: isProduction ? configs.prod.externalHost : 'http://localhost:3000',
    authHost: isProduction ? configs.prod.authHost : configs.test.authHost,
    agroclassesHost: isProduction ? configs.prod.agroclassesHost : configs.dev.agroclassesHost,
  }

  return {
    externalHost: selectedConfig.externalHost,
    authHost: selectedConfig.authHost,
    authHostLoginUrl: `${selectedConfig.authHost}/auth?authFrom=agro`,
    regHostLoginUrl: `${selectedConfig.authHost}/reg?authFrom=agro`,
    authHostLogoutUrl: `${selectedConfig.authHost}/logout`,
    rshbMikroFrontendUrl: isProduction
      ? 'https://retail.rshb.ru/remoteEntry.js'
      : 'https://portal-ui-cc-cprb-dev-rshbdev.sz.rshbcloud.ru/remoteEntry.js',
    agroclassesHost: selectedConfig.agroclassesHost,
  }
}

const withQueryParam = (url: string, key: string, value: string): string => {
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}${key}=${encodeURIComponent(value)}`
}

// backUrl во всех трёх - абсолютный адрес возврата
export const buildLoginUrl = (hosts: EnvironmentHosts, backUrl: string): string =>
  withQueryParam(hosts.authHostLoginUrl, 'backurl', backUrl)

export const buildRegisterUrl = (hosts: EnvironmentHosts, backUrl: string): string =>
  withQueryParam(hosts.regHostLoginUrl, 'backurl', backUrl)

export const buildLogoutUrl = (hosts: EnvironmentHosts, backUrl: string): string =>
  withQueryParam(hosts.authHostLogoutUrl, 'backurl', backUrl)
